module.exports = __webpack_public_path__ + "img/arrow-up.e3272d0b.svg";